import { gql } from 'graphql-request';

export const resendVerificationEmailMutation = gql`
    mutation ResendVerificationEmail($email: String!, $clientOrigin: String!, $redirectState: String) {
        resendVerificationEmail(
            email: $email
            clientOrigin: $clientOrigin
            redirectState: $redirectState
        ) {
            success
        }
    }
`;

export const handleResendVerification = async (
    email: string,
    graphQlClient: any,
    redirectState: string,
) => {
    try {

        const vars = {
            email: email,
            clientOrigin: window.location.origin,
            redirectState: redirectState,
        };

        const response = await graphQlClient(resendVerificationEmailMutation, vars, false);

        if (response?.resendVerificationEmail?.success) {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        console.error('resendVerificationEmail error:', error);
        return false;
    }
};

export type VerificationStatus = 'success' | 'fail' | 'missingToken';

export function getVerificationMessage(status: VerificationStatus) {
    switch (status) {
        case 'success':
            return {
                headingSlug: 'verify-success-heading',
                bodySlug: 'verify-success-body',
                defaultHeading: 'Verified',
                defaultBody: 'You have successfully verified your email address.',
            };
        case 'missingToken':
            return {
                headingSlug: 'verify-missing-token-heading',
                bodySlug: 'verify-missing-token-body',
                defaultHeading: 'Invalid Link',
                defaultBody: 'No token was provided in the link.',
            };

        case 'fail':
        default:
            return {
                headingSlug: 'verify-fail-heading',
                bodySlug: 'verify-fail-body',
                defaultHeading: 'Verification Failed',
                defaultBody: 'Something went wrong. Please try again.',
            };
    }
}

export interface VerificationModalMessage {
    headingSlug?: string;
    bodySlug?: string;
    defaultHeading?: string;
    defaultBody?: string;
}
